module.exports = __webpack_public_path__ + "img/super_wild_win_multiplier.a504ad0d.png";